export default function App() {
  return(
    <div className = "page">
      <a className = "skip-link" href = "main">
        Skip to content
      </a>
      

      <header className = "header">
        <div className = "brand">
          <div className = "logo" aria-hidden="true">WMB</div>
          <div>
            <div className="company">Wild Mountain Bluebonnet</div>
            <div className="tagline">Book Publication Company</div>
          </div>
        </div>

        <nav className="nav" aria-label="Primary">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#catalog">Catalog</a>
          <a href="#contact">Contact</a>
        </nav>

      </header>

      <main id= "main" className="main">
        <section id = "home" className="hero">
          <h1>Comming Sooon</h1>
          <p>
            We are building a home for stories worth keeping. Our website is on the way.
          </p>
          <div className="hero-actions">
            <a className="button" href="#contact">Contact us</a>
            <a className="button secondary" href = "#about">Learn more</a>
          </div>
        </section>
        <section id = "about" className="section">
          <h2>About</h2>
          <p>
            Wild Mountain Bluebonnet is a publishing team focused on thoughtful books and
            beautiful releases. This site is a placeholder while we prepare our catalog.
          </p>
        </section>
                <section id="catalog" className="section">
          <h2>Catalog</h2>
          <p>Catalog listings will appear here soon.</p>
        </section>

        <section id="contact" className="section">
          <h2>Contact</h2>
          <ul className="contact">
            <li><strong>Email:</strong> contact@wildmountainbluebonnet.com</li>
            <li><strong>Phone:</strong> (000) 000-0000</li>
            <li><strong>Location:</strong> City, State</li>
          </ul>
          <p className="note">
            Replace this later with correct info.
          </p>
        </section>
      </main>
      <footer className="footer">
        <p>© {new Date().getFullYear()} Wild Mountain Bluebonnet. All rights reserved.</p>
      </footer>
    </div>
  );
}